<template>
    <div class="row">
        <div class="col-12 my-3"
             :key="format.id + $utils.shortid.generate()"
             v-for="(format, index) in formats">
            <ul class="list-group">
                <li class="list-group-item">
                    <strong>Id:</strong> {{format.id}}
                </li>
                <li class="list-group-item">
                    <strong>Name:</strong> {{format.name}}
                </li>
                <li class="list-group-item">
                    <strong>Virtual:</strong> {{format.virtual}}
                </li>
                <li class="list-group-item">
                    <strong>Height:</strong> {{format.height}}
                </li>
                <li class="list-group-item">
                    <strong>Width:</strong> {{format.width}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'PrinterMaintenance',
    data () {
        return {};
    },
    props: {
        printer: {
            type: Object
        }
    },
    computed: {
        ...mapGetters({formats : 'getFormats'})
    },
    methods: {
        ...mapActions(['getFormatsListAsync'])
    },
    created () {
        if(this.formats) {
            this.getFormatsListAsync();
        }
    }
};

</script>

<style lang="scss" scoped>

</style>
